import { useState } from "react";
import PageFadeIn from "../components/shared/PageFadeIn";
import { data } from "../utils/data";
import { AnimatePresence, motion } from "framer-motion";

const Technology = () => {
	const tech = data.technology;
	const [selected, setSelected] = useState(0);

	return (
		<PageFadeIn>
			<div className='absolute top-0 left-0 w-full h-screen pt-[88px] md:pt-[136px] xl:pt-[212px] bg-technology_mobile md:bg-technology_tablet xl:bg-technology_desktop bg-cover'>
				{/* 03 Space Launch */}
				<div className='xl:w-1/2 md:ml-10 xl:ml-[167px] mb-8 md:mb-[64px] xl:mb-[26px] flex items-center justify-center md:justify-start gap-[18px]'>
					<p className='font-barlow font-bold md:text-20 xl:text-[28px] leading-19 md:leading-[24px] xl:leading-[34px] tracking-27 md:tracking-[3.37px] xl:tracking-[4.725px] text-white opacity-25'>
						03
					</p>
					<p className='font-barlow md:text-20 xl:text-[28px] leading-19 md:leading-[24px] xl:leading-[34px] tracking-27 md:tracking-[3.37px] xl:tracking-[4.725px] text-white uppercase'>
						Space Launch 101
					</p>
				</div>
				{/* all content except 03 space launch */}
				<div className='flex flex-col xl:flex-row-reverse'>
					{/* img */}
					<AnimatePresence exitBeforeEnter>
						<motion.div
							className={`w-full h-[170px] md:h-[310px] xl:w-[515px] xl:h-[527px] ${tech[selected].photo} bg-center bg-cover`}
							key={selected}
							animate={{ opacity: 1 }}
							initial={{ opacity: 0 }}
							exit={{ opacity: 0 }}
							transition={{ duration: 0.4 }}
						/>
					</AnimatePresence>
					{/* picker and info */}
					<div className='w-full xl:w-auto mt-[34px] mb-[26px] md:mt-[56px] md:mb-[44px] xl:ml-10 xl:mt-[111px] xl:mr-[120px] flex flex-col xl:flex-row'>
						{/* picker */}
						<motion.div className='w-[152px] h-[40px] md:w-[210px] md:h-[60px] xl:w-[80px] xl:h-[304px] mx-auto xl:ml-[127px] xl:mr-[80px] flex xl:flex-col items-center justify-between'>
							{tech.map((tech, index) => (
								<div
									key={tech.name}
									className='relative w-[40px] h-[40px] md:w-[60px] md:h-[60px] xl:w-[80px] xl:h-[80px] flex items-center justify-center rounded-full border border-border_grey'
									onClick={() => setSelected(index)}
								>
									<motion.p
										className={`font-bellefair text-16 md:text-[24px] leading-[18px] md:leading[28px] z-10 ${
											index === selected ? "text-black" : "text-white"
										}`}
									>
										{index + 1}
									</motion.p>
									{index === selected && (
										<motion.div
											className='absolute w-[40px] h-[40px] md:w-[60px] md:h-[60px] xl:w-[80px] xl:h-[80px] rounded-full border-0 bg-white'
											layoutId='selected_tech'
										/>
									)}
								</div>
							))}
						</motion.div>
						{/* info */}
						<div className='flex flex-col'>
							<p className='mt-[26px] mb-[9px] md:mt-[44px] md:mb-[16px] xl:m-0 font-barlow text-[14px] md:text-[16px] leading-[17px] md:leading-[19px] text-center xl:text-left tracking-[2.36px] md:tracking-[2.7px] uppercase text-lavender'>
								The terminology...
							</p>
							<AnimatePresence exitBeforeEnter>
								<motion.div
									className='px-[24px] xl:p-0 flex flex-col items-center xl:items-start'
									key={selected}
									animate={{ opacity: 1 }}
									initial={{ opacity: 0 }}
									exit={{ opacity: 0 }}
									transition={{ duration: 0.4 }}
								>
									<p className='mb-4 md:mt-1 md:mb-4 xl:mt-[15px] xl:mb-[27px] font-bellefair text-24 md:text-[40px] xl:text-[56px] leading-[28px] md:leading-[46px] xl:leading-[64px] text-white uppercase'>
										{tech[selected].name}
									</p>
									<p className='md:w-[458px] font-barlow text-[15px] md:text-16 xl:text-[18px] leading-[25px] md:leading-[28px] xl:leading-[32px] tracking-[1.5px] text-lavender text-center xl:text-left'>
										{tech[selected].description}
									</p>
								</motion.div>
							</AnimatePresence>
						</div>
					</div>
				</div>
			</div>
		</PageFadeIn>
	);
};

export default Technology;
